import useTimer from '../../../../../hooks/useTimer'
import { useEffect } from 'react'
import { useToDaysLongHoursLongMinutesLong } from '../../../../../hooks/shared/time/useToDaysLongHoursLongMinutesLong'
import { useTranslation } from '../../../../../translations'

export default function ChallengeSectionTimer({ challengeData }) {
  const { endDate } = challengeData
  const { t } = useTranslation()

  const totalDateValue = endDate || 0

  const [time, { start }] = useTimer(totalDateValue * 1000 - Date.now())

  const toDaysLongHoursLongMinutesLong = useToDaysLongHoursLongMinutesLong()

  useEffect(() => {
    totalDateValue > 0 && start()
  }, [totalDateValue])

  return (
    time > 0 && (
      <div className={'challenges__section-progress-time'}>
        {toDaysLongHoursLongMinutesLong({
          milliseconds: time,
          splitterBetweenParts: ', ',
          daysArray: [
            t('other.days.0.reduction'),
            t('other.days.1.reduction'),
            t('other.days.2.reduction'),
          ],
          hoursArray: [
            t('other.hours.0.reduction'),
            t('other.hours.1.reduction'),
            t('other.hours.2.reduction'),
          ],
          minutesArray: [
            t('other.minutes.0.reduction'),
            t('other.minutes.1.reduction'),
            t('other.minutes.2.reduction'),
          ],
        })}
      </div>
    )
  )
}
